// import { useState } from "react";
// import { Link, NavLink, useLocation } from "react-router-dom";
// import {
//   LayoutDashboard,
//   Users,
//   Building2,
//   Settings,
//   PiggyBank,
//   CreditCard,
//   BarChart3,
//   MessageSquare,
//   Shield,
//   ChevronLeft,
//   Menu,
//   Bot,
//   UserCheck,
//   Package,
//   ShieldCheck,
//   Wallet,
//   Bell,
//   CheckSquare,
//   ArrowRightLeft,
// } from "lucide-react";
// import { cn } from "@/lib/utils";
// import { useAuthStore } from "@/store/auth";
// import { LOGOPATH, PATHS } from "@/lib/paths";
// import { usePermissions } from "@/hooks/use-permissions";
// import { PERMISSIONS } from "@/lib/permissions";

// const navigationConfig = [
//   {
//     name: "Dashboard",
//     href: PATHS.dashboard,
//     icon: LayoutDashboard,
//     requiredPermission: PERMISSIONS.DASHBOARD_READ,
//   },
//   {
//     name: "Approvals",
//     href: PATHS.approvals,
//     icon: CheckSquare,
//     requiredPermission: PERMISSIONS.APPROVALS_READ,
//   },
//   {
//     name: "User Management",
//     href: PATHS.users.root,
//     icon: Users,
//     requiredPermission: PERMISSIONS.USERS_READ,
//   },
//   {
//     name: "Account Management",
//     href: PATHS.accounts.root,
//     icon: Wallet,
//     requiredPermission: PERMISSIONS.ACCOUNTS_READ,
//   },
//   {
//     name: "KYC & Compliance",
//     href: PATHS.compliance.root,
//     icon: ShieldCheck,
//     requiredPermission: PERMISSIONS.KYC_READ,
//   },
//   {
//     name: "Product Control",
//     href: PATHS.products.root,
//     icon: Settings,
//     requiredPermission: PERMISSIONS.PRODUCTS_READ,
//   },
//   {
//     name: "Product Details",
//     href: PATHS.products.details.replace(":productId", "robo_save"),
//     icon: Package,
//     requiredPermission: PERMISSIONS.PRODUCTS_READ,
//     customActiveCheck: true,
//   },
//   {
//     name: "Transaction Ledger",
//     href: PATHS.transactions,
//     icon: ArrowRightLeft,
//     requiredPermission: PERMISSIONS.TRANSACTIONS_READ,
//   },
//   {
//     name: "Loan Management",
//     href: PATHS.loans,
//     icon: CreditCard,
//     requiredPermission: PERMISSIONS.LOANS_READ,
//   },
//   {
//     name: "Analytics",
//     href: PATHS.analytics,
//     icon: BarChart3,
//     requiredPermission: PERMISSIONS.REPORTS_READ,
//   },
//   {
//     name: "Support Centre",
//     href: PATHS.support,
//     icon: MessageSquare,
//     requiredPermission: PERMISSIONS.SUPPORT_TICKETS_READ,
//   },
//   {
//     name: "Notifications",
//     href: PATHS.notifications,
//     icon: Bell,
//     requiredPermission: PERMISSIONS.USERS_READ,
//   },
//   // {
//   //   name: "AI Hub",
//   //   href: PATHS.ai,
//   //   icon: Bot,
//   //   requiredPermission: PERMISSIONS.AI_SETTINGS_READ,
//   // },
//   {
//     name: "Agent Portal",
//     href: PATHS.agents,
//     icon: UserCheck,
//     requiredPermission: PERMISSIONS.AGENTS_READ,
//   },
//   {
//     name: "Security",
//     href: PATHS.security,
//     icon: Shield,
//     requiredPermission: PERMISSIONS.ADMINS_READ,
//   },
// ];

// export function Sidebar() {
//   const [collapsed, setCollapsed] = useState(false);
//   const { user } = useAuthStore();
//   const { hasPermission } = usePermissions();
//   const location = useLocation();

//   const accessibleNavigation = navigationConfig.filter((item) =>
//     hasPermission(item.requiredPermission)
//   );

//   const userInitials =
//     user?.name
//       ?.split(" ")
//       .map((n) => n[0])
//       .join("") || "AD";

//   const isProductDetailsActive = () => {
//     const productDetailsBasePath = PATHS.products.details
//       .replace("/:productId", "")
//       .replace(":productId", "");
//     const productPlanDetailsBasePath = PATHS.products.planDetails
//       .replace("/:productId", "")
//       .replace(":productId", "")
//       .replace("/:subAccountNumber", "")
//       .replace(":subAccountNumber", "");
//     return (
//       location.pathname.startsWith(productDetailsBasePath) ||
//       location.pathname.startsWith(productPlanDetailsBasePath)
//     );
//   };

//   return (
//     <div
//       className={cn(
//         "bg-gradient-to-b from-white via-slate-50/50 to-white border-r border-slate-200/60 transition-all duration-300 flex flex-col shadow-soft h-full",
//         collapsed ? "w-16" : "w-64"
//       )}
//     >
//       {/* Header */}
//       <div className="flex items-center justify-between p-4 border-b border-slate-200/60 flex-shrink-0">
//         {!collapsed && (
//           <div className="flex items-center space-x-3">
//             <div className="w-10 h-10 flex items-center justify-center shadow-soft">
//               <img src={LOGOPATH} alt="RoboBank" className="w-8 h-8" />
//             </div>
//             <span className="font-bold text-lg bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
//               RoboBank
//             </span>
//           </div>
//         )}
//         <button
//           onClick={() => setCollapsed(!collapsed)}
//           className="p-2 rounded-lg hover:bg-slate-100/80 transition-all duration-200 hover:shadow-soft"
//         >
//           {collapsed ? (
//             <Menu className="w-5 h-5 text-slate-600" />
//           ) : (
//             <ChevronLeft className="w-5 h-5 text-slate-600" />
//           )}
//         </button>
//       </div>

//       {/* Navigation */}
//       <nav className="flex-1 px-3 py-6 space-y-2 overflow-y-auto min-h-0">
//         {accessibleNavigation.map((item) => (
//           <NavLink
//             key={item.name}
//             to={item.href}
//             className={({ isActive }) => {
//               const shouldBeActive = item.customActiveCheck
//                 ? isProductDetailsActive()
//                 : isActive;

//               return cn(
//                 "flex items-center px-3 py-3 text-sm font-medium rounded-xl transition-all duration-200 group relative overflow-hidden",
//                 shouldBeActive
//                   ? "bg-gradient-primary text-white shadow-modern"
//                   : "text-slate-700 hover:bg-slate-100/80 hover:text-slate-900 hover:shadow-soft",
//                 collapsed && "justify-center"
//               );
//             }}
//           >
//             <div className="relative z-10 flex items-center">
//               <item.icon className={cn("w-5 h-5", !collapsed && "mr-3")} />
//               {!collapsed && <span className="font-medium">{item.name}</span>}
//             </div>
//           </NavLink>
//         ))}
//       </nav>

//       {/* Footer */}
//       <div className="p-4 border-t border-slate-200/80 bg-purple-50 flex-shrink-0">
//         {!collapsed && (
//           <Link
//             to={PATHS.settings}
//             className="flex items-center space-x-3 p-3 rounded-xl bg-slate-50/80 shadow-soft hover:bg-slate-100 transition-colors duration-200"
//           >
//             <div className="w-10 h-10 bg-gradient-primary rounded-full flex items-center justify-center shadow-soft">
//               <span className="text-sm font-bold text-white">
//                 {userInitials}
//               </span>
//             </div>
//             <div className="flex-1 min-w-0">
//               <p className="text-sm font-semibold text-slate-900 truncate">
//                 {user?.name}
//               </p>
//               <p className="text-xs text-slate-500 truncate">
//                 {user?.role?.name}
//               </p>
//             </div>
//           </Link>
//         )}
//       </div>
//     </div>
//   );
// }

import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Building2,
  Settings,
  PiggyBank,
  CreditCard,
  BarChart3,
  MessageSquare,
  Shield,
  ChevronLeft,
  Menu,
  Bot,
  UserCheck,
  Package,
  ShieldCheck,
  Wallet,
  Bell,
  CheckSquare,
  ArrowRightLeft,
  X,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuthStore } from "@/store/auth";
import { LOGOPATH, PATHS } from "@/lib/paths";
import { usePermissions } from "@/hooks/use-permissions";
import { PERMISSIONS } from "@/lib/permissions";
import { useIsMobile } from "@/hooks/use-mobile";

const navigationConfig = [
  {
    name: "Dashboard",
    href: PATHS.dashboard,
    icon: LayoutDashboard,
    requiredPermission: PERMISSIONS.DASHBOARD_READ,
  },
  {
    name: "Approvals",
    href: PATHS.approvals,
    icon: CheckSquare,
    requiredPermission: PERMISSIONS.APPROVALS_READ,
  },
  {
    name: "User Management",
    href: PATHS.users.root,
    icon: Users,
    requiredPermission: PERMISSIONS.USERS_READ,
  },
  {
    name: "Account Management",
    href: PATHS.accounts.root,
    icon: Wallet,
    requiredPermission: PERMISSIONS.ACCOUNTS_READ,
  },
  {
    name: "KYC & Compliance",
    href: PATHS.compliance.root,
    icon: ShieldCheck,
    requiredPermission: PERMISSIONS.KYC_READ,
  },
  {
    name: "Product Control",
    href: PATHS.products.root,
    icon: Settings,
    requiredPermission: PERMISSIONS.PRODUCTS_READ,
  },
  {
    name: "Product Details",
    href: PATHS.products.details.replace(":productId", "robo_save"),
    icon: Package,
    requiredPermission: PERMISSIONS.PRODUCTS_READ,
    customActiveCheck: true,
  },
  {
    name: "Transaction Ledger",
    href: PATHS.transactions,
    icon: ArrowRightLeft,
    requiredPermission: PERMISSIONS.TRANSACTIONS_READ,
  },
  {
    name: "Loan Management",
    href: PATHS.loans,
    icon: CreditCard,
    requiredPermission: PERMISSIONS.LOANS_READ,
  },
  {
    name: "Analytics",
    href: PATHS.analytics,
    icon: BarChart3,
    requiredPermission: PERMISSIONS.REPORTS_READ,
  },
  {
    name: "Support Centre",
    href: PATHS.support,
    icon: MessageSquare,
    requiredPermission: PERMISSIONS.SUPPORT_TICKETS_READ,
  },
  {
    name: "Notifications",
    href: PATHS.notifications,
    icon: Bell,
    requiredPermission: PERMISSIONS.USERS_READ,
  },
  // {
  //   name: "AI Hub",
  //   href: PATHS.ai,
  //   icon: Bot,
  //   requiredPermission: PERMISSIONS.AI_SETTINGS_READ,
  // },
  {
    name: "Agent Portal",
    href: PATHS.agents,
    icon: UserCheck,
    requiredPermission: PERMISSIONS.AGENTS_READ,
  },
  {
    name: "Security",
    href: PATHS.security,
    icon: Shield,
    requiredPermission: PERMISSIONS.ADMINS_READ,
  },
];

export function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const user = useAuthStore((state) => state.user);
  const { hasPermission } = usePermissions();
  const location = useLocation();
  const isMobile = useIsMobile();

  const accessibleNavigation = navigationConfig.filter((item) =>
    hasPermission(item.requiredPermission)
  );

  const userInitials =
    user?.name
      ?.split(" ")
      .map((n) => n[0])
      .join("") || "AD";

  const isProductDetailsActive = () => {
    const productDetailsBasePath = PATHS.products.details
      .replace("/:productId", "")
      .replace(":productId", "");
    const productPlanDetailsBasePath = PATHS.products.planDetails
      .replace("/:productId", "")
      .replace(":productId", "")
      .replace("/:subAccountNumber", "")
      .replace(":subAccountNumber", "");
    return (
      location.pathname.startsWith(productDetailsBasePath) ||
      location.pathname.startsWith(productPlanDetailsBasePath)
    );
  };

  const handleNavClick = () => {
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  if (isMobile) {
    return (
      <>
        <button
          onClick={() => setMobileOpen(true)}
          className="fixed top-4 left-4 z-40 p-2 rounded-lg bg-white shadow-modern border border-slate-200/60 hover:bg-slate-50 transition-all duration-200 lg:hidden"
        >
          <Menu className="w-5 h-5 text-slate-600" />
        </button>

        {mobileOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setMobileOpen(false)}
          />
        )}

        <div
          className={cn(
            "fixed top-0 left-0 h-full w-64 bg-gradient-to-b from-white via-slate-50 to-white border-r border-slate-200/60 flex flex-col shadow-2xl z-50 transition-transform duration-300 lg:hidden",
            mobileOpen ? "translate-x-0" : "-translate-x-full"
          )}
        >
          <div className="flex items-center justify-between p-4 border-b border-slate-200/60 flex-shrink-0">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 flex items-center justify-center shadow-soft">
                <img src={LOGOPATH} alt="RoboBank" className="w-8 h-8" />
              </div>
              <span className="font-bold text-lg bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                RoboBank
              </span>
            </div>
            <button
              onClick={() => setMobileOpen(false)}
              className="p-2 rounded-lg hover:bg-slate-100/80 transition-all duration-200 hover:shadow-soft"
            >
              <X className="w-5 h-5 text-slate-600" />
            </button>
          </div>

          <nav className="flex-1 px-3 py-6 space-y-2 overflow-y-auto min-h-0">
            {accessibleNavigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                onClick={handleNavClick}
                className={({ isActive }) => {
                  const shouldBeActive = item.customActiveCheck
                    ? isProductDetailsActive()
                    : isActive;

                  return cn(
                    "flex items-center px-3 py-3 text-sm font-medium rounded-xl transition-all duration-200 group relative overflow-hidden",
                    shouldBeActive
                      ? "bg-gradient-primary text-white shadow-modern"
                      : "text-slate-700 hover:bg-slate-100/80 hover:text-slate-900 hover:shadow-soft"
                  );
                }}
              >
                <div className="relative z-10 flex items-center">
                  <item.icon className="w-5 h-5 mr-3" />
                  <span className="font-medium">{item.name}</span>
                </div>
              </NavLink>
            ))}
          </nav>

          <div className="p-4 border-t border-slate-200/80 bg-purple-50 flex-shrink-0">
            <Link
              to={PATHS.settings}
              onClick={handleNavClick}
              className="flex items-center space-x-3 p-3 rounded-xl bg-slate-50/80 shadow-soft hover:bg-slate-100 transition-colors duration-200"
            >
              <div className="w-10 h-10 bg-gradient-primary rounded-full flex items-center justify-center shadow-soft">
                <span className="text-sm font-bold text-white">
                  {userInitials}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-slate-900 truncate">
                  {user?.name}
                </p>
                <p className="text-xs text-slate-500 truncate">
                  {user?.role?.name}
                </p>
              </div>
            </Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <div
      className={cn(
        "bg-gradient-to-b from-white via-slate-50/50 to-white border-r border-slate-200/60 transition-all duration-300 flex flex-col shadow-soft h-full",
        collapsed ? "w-16" : "w-64"
      )}
    >
      <div className="flex items-center justify-between p-4 border-b border-slate-200/60 flex-shrink-0">
        {!collapsed && (
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 flex items-center justify-center shadow-soft">
              <img src={LOGOPATH} alt="RoboBank" className="w-8 h-8" />
            </div>
            <span className="font-bold text-lg bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
              RoboBank
            </span>
          </div>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="p-2 rounded-lg hover:bg-slate-100/80 transition-all duration-200 hover:shadow-soft"
        >
          {collapsed ? (
            <Menu className="w-5 h-5 text-slate-600" />
          ) : (
            <ChevronLeft className="w-5 h-5 text-slate-600" />
          )}
        </button>
      </div>

      <nav className="flex-1 px-3 py-6 space-y-2 overflow-y-auto min-h-0">
        {accessibleNavigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) => {
              const shouldBeActive = item.customActiveCheck
                ? isProductDetailsActive()
                : isActive;

              return cn(
                "flex items-center px-3 py-3 text-sm font-medium rounded-xl transition-all duration-200 group relative overflow-hidden",
                shouldBeActive
                  ? "bg-gradient-primary text-white shadow-modern"
                  : "text-slate-700 hover:bg-slate-100/80 hover:text-slate-900 hover:shadow-soft",
                collapsed && "justify-center"
              );
            }}
          >
            <div className="relative z-10 flex items-center">
              <item.icon className={cn("w-5 h-5", !collapsed && "mr-3")} />
              {!collapsed && <span className="font-medium">{item.name}</span>}
            </div>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-200/80 bg-purple-50 flex-shrink-0">
        {!collapsed && (
          <Link
            to={PATHS.settings}
            className="flex items-center space-x-3 p-3 rounded-xl bg-slate-50/80 shadow-soft hover:bg-slate-100 transition-colors duration-200"
          >
            <div className="w-10 h-10 bg-gradient-primary rounded-full flex items-center justify-center shadow-soft">
              <span className="text-sm font-bold text-white">
                {userInitials}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-slate-900 truncate">
                {user?.name}
              </p>
              <p className="text-xs text-slate-500 truncate">
                {user?.role?.name}
              </p>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}
